import React, { Suspense } from 'react'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ToastContainer from './modules/ToastContainer'
import MainTemplate from './templates/MainTemplate'
import Routes from './routes'
import { StoreProvider } from './context/store'
import PageLoader from './components/PageLoader'
import Network from './components/Network'
import ServiceWorkerWrapper from './components/ServiceWorkerWrapper'
import AutoDataReload from './components/AutoReloadData'

function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <StoreProvider>
        <MainTemplate>
          <>
            <AutoDataReload>
              <Network>
                <Routes />
              </Network>
            </AutoDataReload>
            <ToastContainer position={toast.POSITION.BOTTOM_CENTER} closeButton={false} autoClose={7000} />
          </>
        </MainTemplate>
      </StoreProvider>
      <ServiceWorkerWrapper />
    </Suspense>
  )
}

export default App